import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../utils/api';

const GeneratedChapterPage = () => {
  const { bookId, chapterId } = useParams();
  const navigate = useNavigate();
  const [chapter, setChapter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const generateChapter = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        console.log('Generating chapter for bookId:', bookId, 'chapterId:', chapterId);
        const response = await api.post(`/api/customized-book/generate-chapter/${bookId}/${chapterId}`);
        
        console.log('Generation response:', response.data);
        
        if (response.data.success) {
          setChapter(response.data.chapter);
        } else {
          setError('Failed to generate chapter');
        }
      } catch (err) {
        console.error('Error generating chapter:', err);
        const errorMessage = err.response?.data?.error || 'Failed to generate chapter';
        const missingFields = err.response?.data?.missingFields;
        
        if (missingFields && missingFields.length > 0) {
          setError(`${errorMessage}\n\nMissing settings: ${missingFields.join(', ')}\n\nPlease complete your settings first.`);
        } else {
          setError(errorMessage);
        }
      } finally {
        setIsLoading(false);
      }
    };

    generateChapter();
  }, [bookId, chapterId]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        padding: '20px'
      }}>
        <div style={{ fontSize: '24px', marginBottom: '20px' }}>
          Generating your personalized chapter...
        </div>
        <div style={{ 
          width: '50px', 
          height: '50px', 
          border: '4px solid #f3f3f3', 
          borderTop: '4px solid #3498db', 
          borderRadius: '50%', 
          animation: 'spin 1s linear infinite' 
        }}></div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        padding: '20px'
      }}>
        <div style={{ fontSize: '24px', marginBottom: '20px', color: '#e74c3c' }}>
          Error
        </div>
        <div style={{ fontSize: '16px', marginBottom: '20px', textAlign: 'center' }}>
          {error}
        </div>
        <button 
          onClick={() => navigate(-1)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Go Back
        </button>
      </div>
    );
  }

  if (!chapter) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh' 
      }}>
        <div>No chapter found</div>
      </div>
    );
  }

  return (
    <div className="book-content-container" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      {/* Chapter Banner Image or Title */}
      {chapter.image_url ? (
        <div 
          className="chapter-header-image"
          style={{
            backgroundImage: `url(${chapter.image_url})`,
            height: '200px',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            borderRadius: '8px',
            marginBottom: '20px'
          }}
        >
          <div 
            className="chapter-header-overlay"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              borderRadius: '8px'
            }}
          />
          <h2 
            className="book-chapter-title chapter-title"
            style={{
              position: 'absolute',
              bottom: '20px',
              left: '20px',
              color: 'white',
              margin: 0,
              fontSize: '28px',
              fontWeight: 'bold'
            }}
          >
            {chapter.title}
          </h2>
        </div>
      ) : (
        <h2 
          className="book-chapter-title" 
          style={{ 
            textAlign: 'center', 
            margin: '32px 0 24px 0',
            fontSize: '28px',
            fontWeight: 'bold'
          }}
        >
          {chapter.title}
        </h2>
      )}
      
      <div
        className="book-preview-chapter-content"
        dangerouslySetInnerHTML={{ __html: chapter.content || '<em>No content</em>' }}
        style={{
          lineHeight: '1.6',
          fontSize: '16px'
        }}
      />
      
      <div style={{ 
        marginTop: '40px', 
        textAlign: 'center',
        padding: '20px',
        borderTop: '1px solid #eee'
      }}>
        <button 
          onClick={() => navigate(-1)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '10px'
          }}
        >
          Go Back
        </button>
        <button 
          onClick={() => window.open(`/customized-book/${bookId}`, '_blank')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#27ae60',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          View All Generated Chapters
        </button>
      </div>
    </div>
  );
};

export default GeneratedChapterPage; 